import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { SPT } from 'src/app/shared/model/spt.model';
import { SPTService } from 'src/app/shared/service/spt-access.service';
import { Spinner } from 'src/app/core/services/spinner.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { TicketRequest } from 'src/app/shared/model/ticket-access-request.model';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/shared/components/dialog/confirmation-dialog.component';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { Location } from '@angular/common';
import { SubscriptionLike } from 'rxjs';

@Component({
  selector: 'app-spt-form',
  templateUrl: './spt-form.component.html',
  styleUrls: ['./spt-form.component.scss']
})
export class SptFormComponent implements OnInit, OnDestroy  {
  optionList = ['Yes', 'No'];
  regions = ['CEAP', 'ERCIS', 'INDIA', 'LAM', 'MENAT', 'NAM', 'SUBSAH'];
  spt: SPT = new SPT();
  sptForm: FormGroup;
  request: TicketRequest[] = [];
  isSpin: boolean;
  checkSubmit: boolean;
  subscription: SubscriptionLike;

  constructor(
    private spinner: Spinner,
    private fb: FormBuilder,
    private location: Location,
    private router: Router,
    private dialog: MatDialog,
    private toastService: ToastrService,
    private service: SPTService
  ) {
  }

  ngOnInit(): void {
    this.initFormSpt();
    this.getListTicket();
  }

  getListTicket(event?) {
    if (event) {
      event.srcElement.classList.remove('rotate');
      setTimeout(() => {
        event.srcElement.classList.add('rotate');
      }, 0);
    }
    this.subscription = this.service.getRequestSPTAccessList().subscribe((res) => {
      this.request = res.data;
    }, (err) => {});
  }

  initFormSpt() {
    return this.sptForm = this.fb.group({
      companyName: [this.spt.companyName, [Validators.required]],
      address: [this.spt.address, [Validators.required]],
      city: [this.spt.city, [Validators.required]],
      country: [this.spt.country, [Validators.required]],
      region: [this.spt.region, [Validators.required]],
      email: [this.spt.email, [Validators.required]],
      contactName: [this.spt.contactName, [Validators.required]],
      phone: [this.spt.phone, [Validators.required]],
      SAPID: [this.spt.SAPID, [Validators.required]],
    });
  }

  ngOnDestroy() {
    // unsubscribe
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  /**
   * Marks all controls in a form group as touched
   * @param formGroup - The form group to touch
   */
  private markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  submitSptFormForm(): void {
    if (this.checkSubmit) {
      this.setErrorForm(this.sptForm);
    }
    if (!this.sptForm.valid) {
      this.markFormGroupTouched(this.sptForm);
      return;
    } else {
      this.openDialog();
    }
  }

  checkValid(SAPID) {
    if (SAPID.value === 'Yes') {
      this.sptForm.addControl('provideSAPID', this.fb.control(this.spt.provideSAPID, [Validators.required]));
    } else {
      this.sptForm.removeControl('provideSAPID');
    }
  }

  goToApplication() {
    window.open('https://oscar.ren.apps.ge.com/');
  }

  getInitFormByID(id) {
    this.spinner.show();
    this.service.getRequestSPTAccess(id).subscribe((res) => {
      this.spinner.hide();
      this.spt = new SPT(res.data);
      this.initFormSpt();
    });
  }

  openDialog() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: MESSAGE_TOAST.CONFIRM_REQUEST_ACCESS,
        buttonText: {
          ok: 'Yes',
          cancel: 'No'
        }
      }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        const body = new SPT(this.sptForm.getRawValue(), false).convertToReqBody();
        this.spinner.show();
        this.service.requestSPTAccess(body).subscribe((res) => {
          this.spinner.hide();
          this.toastService.success(MESSAGE_TOAST.REQUEST_ACCESS_TICKET_SUCCESS);
          // this.getListTicket();
          setTimeout(() => {
            location.reload();
          }, 1000);
          // this.resetForm(this.sptForm);
        });
      }
    });
  }

  resetForm(formGroup: FormGroup) {
    let control: AbstractControl = null;
    formGroup.reset();
    formGroup.controls.SAPID.setValue('Yes');
    formGroup.markAsUntouched();
    Object.keys(formGroup.controls).forEach((name) => {
      control = formGroup.controls[name];
      control.setErrors(null);
    });
    formGroup.setErrors({ invalid: true });
    this.checkSubmit = true;
  }

  setErrorForm(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((name) => {
      if (!formGroup.controls[name].value) {
        formGroup.controls[name].setErrors({ nodata: true });
      }
    });
    return formGroup;
  }
}
